import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_COMPANY_LIST = 'FETCH_COMPANY_LIST'
export const RECEIVE_COMPANY_LIST = 'RECEIVE_COMPANY_LIST'
export const FAILED_COMPANY_LIST = 'FAILED_COMPANY_LIST'

export function fetchCompanyList(){

    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_COMPANY_LIST});
        axios({
            method: 'post',
            url: API_LINKS.COMPANY_SETTING_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_COMPANY_LIST,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_COMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_COMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_COMPANY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_COMPANY_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_COMPANY_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_COMPANY_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export const FETCH_COMPANY_LIST_ALL = 'FETCH_COMPANY_LIST_ALL'
export const RECEIVE_COMPANY_LIST_ALL = 'RECEIVE_COMPANY_LIST_ALL'
export const FAILED_COMPANY_LIST_ALL = 'FAILED_COMPANY_LIST_ALL'

export function fetchCompanyListAll(specificCompanyType=null){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_COMPANY_LIST_ALL});
        axios({
            method: 'post',
            url: API_LINKS.COMPANY_LIST_ALL_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_COMPANY_LIST_ALL,
                payload: response.data,
                specificCompanyType
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_COMPANY_LIST_ALL
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_COMPANY_LIST_ALL
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_COMPANY_LIST_ALL
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_COMPANY_LIST_ALL
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_COMPANY_LIST_ALL
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_COMPANY_LIST_ALL
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}